const KEEP_PREFIXES = [
  'mls:',
  'nettgrav:mls_',
  'messenger-v2:mls:',
  'nettgrav.browser.installation_id.',
];

const shouldKeepKey = (key) => {
  if (!key) return false;
  return KEEP_PREFIXES.some((prefix) => key.startsWith(prefix));
};

const clearStoragePreserveMls = (storage) => {
  if (!storage) return;
  try {
    const keys = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key && !shouldKeepKey(key)) {
        keys.push(key);
      }
    }
    keys.forEach((key) => {
      try { storage.removeItem(key); } catch {}
    });
  } catch {}
};

export const clearLocalStoragePreserveMls = () => {
  if (typeof window === 'undefined') return;
  clearStoragePreserveMls(window.localStorage);
};

export const clearSessionStoragePreserveMls = () => {
  if (typeof window === 'undefined') return;
  clearStoragePreserveMls(window.sessionStorage);
};
